import './ZoomCursors.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var cursorStyle = _7a468({defaultClassName:'_1idfwsm2-3-8-0',variantClassNames:{isPanEnabled:{true:'_1idfwsm0-3-8-0',false:'_1idfwsm1-3-8-0'}},defaultVariants:{},compoundVariants:[]});
export var defaultCursor = '_1idfwsm1-3-8-0';
export var resizeCursor = '_1idfwsm0-3-8-0';